export const ALL_PRODUCTS = 'all-products';
export const LISTS = 'lists';
export const CART = 'cart';
export const WISHLIST = 'wishlist';
